const API_URL = process.env.REACT_APP_API_URL || '';

// Event fuer Session-Ablauf
export const sessionExpiredEvent = new EventTarget();

export const httpClient = async (endpoint, options = {}) => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_URL}${endpoint}`;
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    ...options.headers,
  };
  
  
  const token = localStorage.getItem('token');
  const sessionId = localStorage.getItem('sessionId');

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (sessionId) {
    headers['X-Session-Id'] = sessionId;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    // Parse error response
    let errorData = {};
    try {
      errorData = await response.json();
    } catch (e) {
      // Ignore parse errors
    }

    const error = new Error(errorData.error || `HTTP Error: ${response.status}`);
    error.status = response.status;
    error.code = errorData.code;

    // Bei Session-Problemen: Event ausloesen
    if (response.status === 401 && (errorData.code === 'SESSION_EXPIRED' || errorData.code === 'SESSION_INVALID')) {
      sessionExpiredEvent.dispatchEvent(new CustomEvent('sessionExpired', { detail: errorData }));
    }

    throw error;
  }

  const text = await response.text();
  return text ? JSON.parse(text) : null;
};

export default httpClient;
